import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchWrapper } from "../utils/fetch-wrapper";

const name = "user";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

export const userActions = { ...createSlice.actions, ...extraActions };
export const userReducer = slice.reducer;

function createInitialState() {
    return {
        user: {},
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/user`;

    return {
        getAll: getAll(),
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll(),
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;

        return {
            [pending]: (state) => {
                state.user = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.user = action.payload;
            },
            [rejected]: (state, action) => {
                state.user = { error: action.error };
            },
        };
    }
}
